// aluCategories.js — reference-catalog grouping + plain-language blurbs (aluminum).
// Pure data/helpers. Buckets derive from alu_catalog.type; blurbs are vendor-facing.

export const CATALOG_CATEGORIES = ['Windows', 'Doors'];

export function catalogCategory(type = '') {
  const t = String(type).toLowerCase();
  // DOS categorias, no tres. "Sliding" es un MECANISMO, no una familia:
  // la misma corrediza va al patio o divide sala/oficina, y una sliding
  // window es una VENTANA. El orden viejo hacia ganar 'sliding' sobre
  // 'window' y mandaba las ventanas corredizas al tab de puertas.
  if (t.includes('window')) return 'Windows';   // incluye "sliding window"
  if (t.includes('door'))   return 'Doors';     // sliding / lift / barn / garage
  return 'Windows';
}

const TYPE_BLURB = {
  'fixed window':        'Fixed — does not open, maximum view',
  'casement window':     'Casement — cranks outward to open',
  'awning window':       'Awning — top-hinged, vents in the rain',
  'tilt & turn window':  'Tilt & turn — tilts to vent or swings open',
  'bifolding window':    'Bi-fold — folds accordion-style',
  'window wall':         'Window wall — mulled modular units',
  'hinged door':         'Hinged — single swinging leaf',
  'french door':         'French — two swinging leaves',
  'storefront door':     'Storefront — commercial, rail & kick',
  'bifolding door':      'Bi-fold door — folds accordion-style',
  'sliding door':        'Sliding — O/X panels (X slides)',
  'lift & sliding door': 'Lift & slide — large panels',
};

export function catalogBlurb(type = '') {
  return TYPE_BLURB[String(type).toLowerCase()] || String(type);
}